import React, { useEffect, useState } from "react";
import { useRedirect } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Button, Chip, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import {
  CurriculumDisicplineTypes,
  DISCIPLINES,
  FOR_UPDATE,
  StudentServicePath,
  WEEKLY_SCHEDULE,
} from "utils/constants";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import dataProvider from "server/dataProvider";
import { MobileListRow } from "features/MobileListRow";

const getDisciplineTypeColor = type => {
  switch (type) {
    case CurriculumDisicplineTypes.Facultative:
      return "#f4ecd7";
    case CurriculumDisicplineTypes.Elective:
      return "#d7f4fa";
    default:
      return null;
  }
};

const WeeklyScheduleMobileExpanded = ({ record }) => {
  const redirect = useRedirect();
  const notifyError = useNotifyError();

  const [disciplines, setDisciplines] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const handleAdd = ({ disciplineId }) => {
    redirect(
      `/${StudentServicePath}${WEEKLY_SCHEDULE}/create?disciplineId=${disciplineId}` +
        `&curriculumId=${record.curriculumId}&studyTypeId=${record.studyTypeId}&academicYearSessionId=${record.academicYearSessionId}` +
        `&instructionLanguageId=${record.instructionLanguageId}&academicYearId=${record.academicYearId}` +
        `&specialityId=${record.specialityId}`,
    );
  };

  useEffect(() => {
    if (!expanded) return;
    dataProvider
      .customRequest(studentRequests.getWeeklyScheduleExpanded(record.id), null, "GET")
      .then(data => setDisciplines(data.data))
      .catch(notifyError);
  }, [expanded, record.id, notifyError]);

  return (
    <Accordion
      sx={{ width: "100%" }}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
        <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
        {disciplines.map((rec, idx) => (
          <div
            key={rec.disciplineId ?? idx}
            style={{ borderBottom: "1px solid #d6d1d0a3", paddingBottom: "0.5rem", marginBottom: "0.5rem" }}
          >
            {rec.curriculumDisciplineTypeName && (
              <MobileListRow
                fields={[
                  {
                    label: "Код",
                    value: (
                      <Chip
                        label={rec.curriculumDisciplineTypeName}
                        size="small"
                        sx={{ bgcolor: getDisciplineTypeColor(rec.curriculumDisciplineType) }}
                      />
                    ),
                  },
                ]}
              />
            )}
            <MobileListRow fields={[{ label: "Дисциплини", value: rec.disciplineName }]} />
            <MobileListRow
              fields={[
                {
                  label: "Въведено разписание?",
                  value: rec.hasSchedule ? (
                    <CheckIcon
                      color="success"
                      sx={{ verticalAlign: "middle", marginBottom: "3px" }}
                    />
                  ) : (
                    <ClearIcon
                      color="error"
                      sx={{ verticalAlign: "middle", marginBottom: "3px" }}
                    />
                  ),
                },
              ]}
            />
            {rec.hasSchedule ? (
              <SecuredComponent permission={permissions.canUpdateEverythingInWeeklySchedules}>
                <Button
                  onClick={() =>
                    redirect(
                      `/${StudentServicePath}${WEEKLY_SCHEDULE}/${rec.weeklyScheduleId}/${DISCIPLINES}/${rec.disciplineId}/${FOR_UPDATE}?curriculumId=${record?.curriculumId}&specialityId=${record?.specialityId}&academicYearSessionId=${record?.academicYearSessionId}`,
                    )
                  }
                  size="small"
                  variant="contained"
                  color="warning"
                  startIcon={<EditIcon />}
                >
                  Редактирай
                </Button>
              </SecuredComponent>
            ) : (
              <Button
                onClick={() => handleAdd({ disciplineId: rec.disciplineId })}
                size="small"
                variant="contained"
                startIcon={<AddIcon />}
              >
                Добави
              </Button>
            )}
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default WeeklyScheduleMobileExpanded;
